export default "__VITE_ASSET__DbRO4v0R__"